'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _gatsbyImage = require('gatsby-image');

var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// A React component that takes a Gatsby File node and renders either a
// gatsby-image component or a native <img> element depending on whether or not
// the node is of type ImageSharp.
exports.default = function (_ref) {
  var node = _ref.node,
      props = _objectWithoutProperties(_ref, ['node']);

  if (node.childImageSharp && node.childImageSharp.fluid) {
    return _react2.default.createElement(_gatsbyImage2.default, _extends({ fluid: node.childImageSharp.fluid }, props));
  }

  if (node.childImageSharp && node.childImageSharp.fixed) {
    return _react2.default.createElement(_gatsbyImage2.default, _extends({ fixed: node.childImageSharp.fixed }, props));
  }

  // eslint-disable-next-line jsx-a11y/alt-text
  return _react2.default.createElement('img', _extends({ src: node.publicURL }, props));
};